import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from '../../../utils/createSignedRequest';

export const postCreateAndUpdateProjectAssignments = async (
  projectId,
  assignmentsToCreate,
  assignmentsToUpdate
) => {
  const apiPath = `projects/${projectId}/assignments/create-and-update-assignments`;

  const request = {
    // url: `http://localhost:3001/${apiPath}`,
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'POST',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ assignmentsToCreate, assignmentsToUpdate }), // aws4 looks for body; axios for data
    data: { assignmentsToCreate, assignmentsToUpdate },
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios(signedRequest);

  return response.data;
};
